import { Apple, Play, MessageCircle, ShieldCheck } from "lucide-react";
import { WALLET, helpPrefill } from "../lib/pay";
import { useRequestPrefill } from "../context/RequestPrefill";

// Pulsante "Scrivi a Kimberly": apre il modulo messaggi del sito gia' compilato (aiuto pagamento).
export const WriteToKimberly = ({ item, code, className = "", testId = "write-kimberly-button" }) => {
  const { setPrefill } = useRequestPrefill();
  const go = () => {
    setPrefill(helpPrefill({ item, code }));
    window.__navigate?.("/richiesta", { state: { scrollTo: "richieste" } });
  };
  return (
    <button type="button" data-testid={testId} onClick={go} className={`btn-ghost-lux flex min-h-[44px] items-center justify-center gap-2 rounded-xl px-4 text-xs font-semibold uppercase tracking-[0.14em] ${className}`}>
      <MessageCircle className="h-4 w-4" /> Scrivi a Kimberly
    </button>
  );
};

// Link ufficiali App Store / Play Store del wallet consigliato
export const StoreLinks = ({ compact = false }) => (
  <div className={`flex flex-wrap gap-2 ${compact ? "" : "sm:gap-3"}`} data-testid="wallet-store-links">
    <a data-testid="wallet-store-ios" href={WALLET.ios} target="_blank" rel="noopener noreferrer" className="btn-ghost-lux flex min-h-[44px] flex-1 items-center justify-center gap-2 rounded-xl px-3 text-[11px] font-semibold uppercase tracking-[0.12em]"><Apple className="h-4 w-4" /> App Store</a>
    <a data-testid="wallet-store-android" href={WALLET.android} target="_blank" rel="noopener noreferrer" className="btn-ghost-lux flex min-h-[44px] flex-1 items-center justify-center gap-2 rounded-xl px-3 text-[11px] font-semibold uppercase tracking-[0.12em]"><Play className="h-4 w-4" /> Play Store</a>
  </div>
);

// Guida in 3 passi, tono diretto, per chi non ha mai usato un wallet
const STEPS = [
  ["Scarica Tonkeeper", "App Store o Play Store, 1 minuto. E' un wallet tuo: nessuno puo' bloccarlo."],
  ["Compra TON con la carta", "Dentro l'app: Compra, importo, carta. Pochi minuti."],
  ["Torna qui e paga", "Premi Paga con wallet, confermi, fatto. Riconosco il pagamento da solo."],
];

export const WalletSteps = ({ item, code }) => (
  <div className="rounded-2xl border border-[rgba(0,175,240,0.18)] bg-[#0b0b0d] p-4" data-testid="wallet-steps">
    <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.22em] text-[color:var(--blush)]"><ShieldCheck className="h-3.5 w-3.5" /> Come fare in 3 passi</div>
    <ol className="mt-3 space-y-2.5">
      {STEPS.map(([t, d], i) => (
        <li key={i} className="flex gap-3 text-sm">
          <span className="font-mono text-[color:var(--gold)]">0{i + 1}</span>
          <span><span className="text-[#f5f2ee]">{t}</span><span className="block text-xs text-[#8a847d]">{d}</span></span>
        </li>
      ))}
    </ol>
    <div className="mt-4"><StoreLinks compact /></div>
    <div className="mt-3 flex flex-wrap items-center justify-between gap-2 border-t border-[rgba(242,215,208,0.1)] pt-3">
      <span className="text-xs text-[#8a847d]">Non ti torna qualcosa? Ti do io l'indirizzo.</span>
      <WriteToKimberly item={item} code={code} testId="wallet-steps-write" />
    </div>
  </div>
);
